import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgTreeLayout = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 59 38"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M27 1.449a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2.891l-.035 3.282h14.248c1.288 0 2.333 1.036 2.415 2.337l.005.163V19.2h4.008a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-3.932v4.195c0 .784.568 1.421 1.285 1.493l.136.007h4.511v-1.695a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-1.305h-4.51c-1.289 0-2.334-1.036-2.416-2.336l-.005-.164-.001-4.195H36.75a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.992V15.23c0-.783-.567-1.42-1.284-1.493l-.136-.007H24.064l-.059 5.468h3.745a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h3.055l.058-5.468H7.989c-.734 0-1.344.591-1.414 1.355l-.006.145-.001 3.968h4.182a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.818V15.23c0-1.32.995-2.41 2.261-2.494l.16-.006h14.885l.035-3.282H19a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h8Zm29.75 28.95h-8a.8.8 0 0 0-.794.7l-.006.1v4a.8.8 0 0 0 .7.793l.1.007h8a.8.8 0 0 0 .794-.7l.006-.1v-4a.8.8 0 0 0-.7-.794l-.1-.006Zm-29-10h-8a.8.8 0 0 0-.794.7l-.006.1v4a.8.8 0 0 0 .7.793l.1.007h8a.8.8 0 0 0 .794-.7l.006-.1v-4a.8.8 0 0 0-.7-.794l-.1-.006Zm-17 0h-8a.8.8 0 0 0-.794.7l-.006.1v4a.8.8 0 0 0 .7.793l.1.007h8a.8.8 0 0 0 .794-.7l.006-.1v-4a.8.8 0 0 0-.7-.794l-.1-.006Zm34 0h-8a.8.8 0 0 0-.794.7l-.006.1v4a.8.8 0 0 0 .7.793l.1.007h8a.8.8 0 0 0 .794-.7l.006-.1v-4a.8.8 0 0 0-.7-.794l-.1-.006Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgTreeLayout)
const Memo = memo(ForwardRef)
export default Memo
